import ApiService from "../api/api.service";
import defaultBoard from './../store/modules/default-board';
export function uuid () {
    return Math.random().toString(16).slice(2)
}

export function saveStatePlugin (store) {
    store.subscribe(
        (mutation, state) => {
            let url = window.location.href;
            let urlArray = url.split('/');
            // saved in the database
            if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                let docUrlId = urlArray[5];

                if(state.board.user.id) {
                    let userData = JSON.parse(localStorage.getItem('user'));
                    if((state.board.team_id == null || state.board.team_id != userData.team_id || !state.board.team_shared) && userData.id != state.board.user.id) {                        return;
                    }
                }


                ApiService.setHeader();
                ApiService.put('/api/document/' + state.board.document_db_id,
                    state.board);
            } else {
                // New
                ApiService.setHeader();
                ApiService.post('/api/document',
                    state.board)
                    .then(({data}) => {

                        // updated documents count etc.
                        ApiService.setHeader();
                        ApiService.get('/api/user').then(({data}) => {
                            window.localStorage.setItem('user', JSON.stringify(data));
                        }).catch(error => {
                            throw new Error('failed to load user');
                        });

                        if(data.doc.id) {
                            state.board.document_db_id = data.doc.id;
                            state.board.document_url_id = data.doc.document_id;
                            state.board.entity_id = data.doc.entity_id;
                            state.board.user = data.doc.user;
                            window.history.replaceState(null, null, '/apps/analytics-planner/'+data.doc.document_id);
                        }
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            }
        }
    )
}



export function saveModelPlannerStatePlugin (store) {
    store.subscribe(
        (mutation, state) => {
            let url = window.location.href;
            let urlArray = url.split('/');
            // saved in the database
            if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                let docUrlId = urlArray[5];

                if(state.board.user.id) {
                    let userData = JSON.parse(localStorage.getItem('user'));
                    if((state.board.team_id == null || state.board.team_id != userData.team_id || !state.board.team_shared) && userData.id != state.board.user.id) {                        return;
                    }
                }


                ApiService.setHeader();
                ApiService.put('/api/document/' + state.board.document_db_id,
                    state.board);
            } else {
                // New
                ApiService.setHeader();
                ApiService.post('/api/document',
                    state.board)
                    .then(({data}) => {

                        // updated documents count etc.
                        ApiService.setHeader();
                        ApiService.get('/api/user').then(({data}) => {
                            window.localStorage.setItem('user', JSON.stringify(data));
                        }).catch(error => {
                            throw new Error('failed to load user');
                        });

                        if(data.doc.id) {
                            state.board.document_db_id = data.doc.id;
                            state.board.document_url_id = data.doc.document_id;
                            state.board.entity_id = data.doc.entity_id;
                            state.board.user = data.doc.user;
                            window.history.replaceState(null, null, '/apps/model-planner/'+data.doc.document_id);
                        }
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            }
        }
    )
}

export function savePipelinePlannerStatePlugin (store) {
    store.subscribe(
        (mutation, state) => {
            let url = window.location.href;
            let urlArray = url.split('/');
            // saved in the database
            if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                let docUrlId = urlArray[5];

                if(state.board.user.id) {
                    let userData = JSON.parse(localStorage.getItem('user'));
                    if((state.board.team_id == null || state.board.team_id != userData.team_id || !state.board.team_shared) && userData.id != state.board.user.id) {                        return;
                    }
                }


                ApiService.setHeader();
                ApiService.put('/api/document/' + state.board.document_db_id,
                    state.board);
            } else {
                // New
                ApiService.setHeader();
                ApiService.post('/api/document',
                    state.board)
                    .then(({data}) => {

                        // updated documents count etc.
                        ApiService.setHeader();
                        ApiService.get('/api/user').then(({data}) => {
                            window.localStorage.setItem('user', JSON.stringify(data));
                        }).catch(error => {
                            throw new Error('failed to load user');
                        });

                        if(data.doc.id) {
                            state.board.document_db_id = data.doc.id;
                            state.board.document_url_id = data.doc.document_id;
                            state.board.entity_id = data.doc.entity_id;
                            state.board.user = data.doc.user;
                            window.history.replaceState(null, null, '/apps/pipeline-planner/'+data.doc.document_id);
                        }
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            }
        }
    )
}


export function savePriorityStatePlugin (store) {
    store.subscribe(
        (mutation, state) => {
            let url = window.location.href;
            let urlArray = url.split('/');

            if(! state.board.description) {
                state.board.description = 'My first project'
            }
            // saved in the database
            if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                let docUrlId = urlArray[5];

                if(state.board.user.id) {
                    let userData = JSON.parse(localStorage.getItem('user'));
                    if((state.board.team_id == null || state.board.team_id != userData.team_id || !state.board.team_shared) && userData.id != state.board.user.id) {
                        return;
                    }
                }

                ApiService.setHeader();
                ApiService.put('/api/document/' + state.board.document_db_id,
                    state.board);
            } else {
                // New
                ApiService.setHeader();
                ApiService.post('/api/document',
                    state.board)
                    .then(({data}) => {
                        // updated documents count etc.
                        ApiService.setHeader();
                        ApiService.get('/api/user').then(({data}) => {
                            window.localStorage.setItem('user', JSON.stringify(data));
                        }).catch(error => {
                            throw new Error('failed to load user');
                        });

                        if(data.doc.id) {
                            state.board.document_db_id = data.doc.id;
                            state.board.document_url_id = data.doc.document_id;
                            state.board.entity_id = data.doc.entity_id;
                            state.board.user = data.doc.user;
                            window.history.replaceState(null, null, '/apps/priorities-matrix/'+data.doc.document_id);
                        }


                    })
                    .catch((response) => {
                        console.log(response);
                    });
            }
        }
    )
}

